import { Loader2 } from "lucide-react";

export default function Loader({ text = "Loading..." }) {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center py-4">
      <Loader2
        size={40}
        className="mb-2"
        style={{
          color: "var(--brand-blue)",
          animation: "spin 1s linear infinite",
        }}
      />
      <span style={{ color: "var(--brand-slate)", fontWeight: 500 }}>{text}</span>
      <style>
        {`
          @keyframes spin {
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}